import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
app-deficiency-step-page {
  display: block;
  margin-top: ${dt('deficiencyStepTable.pageTitleGap')};
}

app-deficiency-step-page .deficiency-step-accordion-sections-grid {
  gap: ${dt('deficiencyStepTable.accordionGroup.sectionGap')} !important;
}

app-deficiency-step-page .deficiency-step-accordion-section {
  display: flex;
  flex-direction: column;
  gap: ${dt('deficiencyStepTable.accordionGroup.contentGap')};
  padding-bottom: ${dt('deficiencyStepTable.accordionGroup.sectionsMarginBottom')} !important;
}

app-deficiency-step-page .deficiency-step-accordion-subtitle,
app-sanction-step-page .deficiency-step-accordion-subtitle {
  margin: 0;
  font-size: ${dt('deficiencyStepTable.accordionGroup.subtitleFontSize')};
  font-weight: ${dt('deficiencyStepTable.accordionGroup.subtitleFontWeight')};
  line-height: ${dt('deficiencyStepTable.accordionGroup.subtitleLineHeight')};
  color: ${dt('deficiencyStepTable.accordionGroup.subtitleColor')};
  overflow-wrap: break-word;
}

app-deficiency-step-page .deficiency-step-card,
app-sanction-step-page .deficiency-step-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  padding: ${dt('deficiencyStepTable.card.padding')};
  border: 1px solid ${dt('deficiencyStepTable.card.borderColor')};
  border-radius: ${dt('deficiencyStepTable.card.borderRadius')};
  background: ${dt('deficiencyStepTable.card.background')};
}

app-deficiency-step-page .deficiency-step-empty-card {
  display: flex;
  flex-direction: column;
  gap: ${dt('deficiencyStepTable.accordionGroup.contentGap')};
  width: 100%;
  box-sizing: border-box;
  padding: ${dt('deficiencyStepTable.emptyCard.padding')};
  border: 1px solid ${dt('deficiencyStepTable.card.borderColor')};
  border-radius: ${dt('deficiencyStepTable.card.borderRadius')};
  background: ${dt('deficiencyStepTable.card.background')};
}

app-deficiency-step-page .deficiency-step-card app-accordion-section {
  display: block;
  width: 100%;
}

app-deficiency-step-page .deficiency-step-card app-accordion-section .p-accordion {
  display: flex;
  flex-direction: column;
  gap: 0;
}

app-deficiency-step-page .deficiency-step-card app-accordion-section .p-accordionpanel > .p-accordionheader,
app-deficiency-step-page .deficiency-step-card app-accordion-section .p-accordionpanel.p-accordionpanel-active > .p-accordionheader {
  background: ${dt('deficiencyStepTable.accordionHeader.background')} !important;
  border: none !important;
  border-radius: ${dt('deficiencyStepTable.accordionHeader.borderRadius')} !important;
  box-shadow: none !important;
}

app-deficiency-step-page .deficiency-step-card app-accordion-section .p-accordionpanel > .p-accordionheader:hover,
app-deficiency-step-page .deficiency-step-card app-accordion-section .p-accordionpanel.p-accordionpanel-active > .p-accordionheader:hover,
app-deficiency-step-page .deficiency-step-card app-accordion-section .p-accordionpanel > .p-accordionheader:focus-within,
app-deficiency-step-page .deficiency-step-card app-accordion-section .p-accordionpanel.p-accordionpanel-active > .p-accordionheader:focus-within {
  background: ${dt('deficiencyStepTable.accordionHeader.background')} !important;
}

app-deficiency-step-page .deficiency-step-card app-accordion-section .p-accordionheader-link {
  background: transparent !important;
  color: ${dt('deficiencyStepTable.accordionHeader.color')} !important;
  font-size: ${dt('deficiencyStepTable.accordionHeader.fontSize')} !important;
  font-weight: ${dt('deficiencyStepTable.accordionHeader.fontWeight')} !important;
  line-height: ${dt('deficiencyStepTable.accordionHeader.lineHeight')} !important;
  padding: ${dt('deficiencyStepTable.accordionHeader.padding')} !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

app-deficiency-step-page .deficiency-step-card app-accordion-section .p-accordionheader-link:hover,
app-deficiency-step-page .deficiency-step-card app-accordion-section .p-accordionheader-link:focus-visible {
  background: transparent !important;
  color: ${dt('deficiencyStepTable.accordionHeader.color')} !important;
}

app-deficiency-step-page .deficiency-step-card app-accordion-section .accordion-section-header-title {
  color: inherit !important;
  font-size: inherit !important;
  font-weight: inherit !important;
  line-height: inherit !important;
}

app-deficiency-step-page .deficiency-step-card app-accordion-section .p-accordioncontent {
  border: none !important;
  background: ${dt('deficiencyStepTable.card.background')} !important;
}

app-deficiency-step-page .deficiency-step-card app-accordion-section .p-accordioncontent-content {
  padding: 0 !important;
}

app-deficiency-step-page .deficiency-step-card app-accordion-section .accordion-section-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${dt('deficiencyStepTable.accordionGroup.contentGap')};
  padding: ${dt('deficiencyStepTable.accordionContent.padding')} 0 0;
  width: 100%;
  box-sizing: border-box;
}

app-deficiency-step-page app-previous-deficiencies-section .previous-deficiencies-accordion-groups {
  display: flex;
  flex-direction: column;
  gap: ${dt('deficiencyStepTable.accordionGroup.previousGroupedAccordionsGap')};
}

app-deficiency-step-page app-accordion-section .accordion-section-header-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

app-additional-deficiencies-section .app-editable-row-table thead th:nth-child(1) {
  width: ${dt('deficiencyStepTable.additionalDeficienciesTable.colWidths.createdDate')};
}
app-additional-deficiencies-section .app-editable-row-table thead th:nth-child(2) {
  width: ${dt('deficiencyStepTable.additionalDeficienciesTable.colWidths.activities')};
}
app-additional-deficiencies-section .app-editable-row-table thead th:nth-child(3) {
  width: ${dt('deficiencyStepTable.additionalDeficienciesTable.colWidths.deficiencies')};
}
app-additional-deficiencies-section .app-editable-row-table thead th:nth-child(4) {
  width: ${dt('deficiencyStepTable.additionalDeficienciesTable.colWidths.directions')};
}
app-additional-deficiencies-section .app-editable-row-table thead th:nth-child(5) {
  width: ${dt('deficiencyStepTable.additionalDeficienciesTable.colWidths.deadline')};
}

app-additional-deficiencies-section .app-editable-row-table tbody td app-date-field,
app-additional-deficiencies-section .app-editable-row-table tbody td app-inspection-activity-select,
app-additional-deficiencies-section .app-editable-row-table tbody td app-multiline-field,
app-additional-deficiencies-section .app-editable-row-table tbody td app-select {
  display: ${dt('inspectionTables.table.cellControlDisplay')};
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

app-additional-deficiencies-section .app-editable-row-table tbody td app-inspection-activity-select .p-multiselect,
app-additional-deficiencies-section .app-editable-row-table tbody td app-multiline-field textarea {
  width: 100%;
  max-width: 100%;
}

/* Reset control-wrapper spacing so table-embedded inputs share one baseline. */
app-detected-deficiencies-section table.inspection-step-table tbody td app-date-field > div,
app-detected-deficiencies-section table.inspection-step-table tbody td app-multiline-field > div,
app-detected-deficiencies-section table.inspection-step-table tbody td .inspection-activity-select-root,
app-additional-deficiencies-section .app-editable-row-table tbody td app-date-field > div,
app-additional-deficiencies-section .app-editable-row-table tbody td app-multiline-field > div,
app-additional-deficiencies-section .app-editable-row-table tbody td .inspection-activity-select-root {
  margin: 0;
  gap: 0;
}

/* Reset control-wrapper spacing (previous deficiencies table).
   Override grid->flex to eliminate phantom grid-track height from empty label/validation rows. */
app-previous-deficiencies-section table.inspection-step-table tbody td app-date-field > div,
app-previous-deficiencies-section table.inspection-step-table tbody td app-select > div {
  display: flex;
  flex-direction: column;
  margin: 0;
  gap: 0;
}

app-inspection-activity-select .p-multiselect-label,
app-inspection-activity-select .app-chip-item .p-chip-label {
  color: ${dt('deficiencyStepTable.activitySelect.selectedTextColor')} !important;
}

.inspection-activity-select-panel .p-multiselect-option,
.inspection-activity-select-panel .p-multiselect-option .p-multiselect-option-label {
  color: ${dt('deficiencyStepTable.activitySelect.optionTextColor')} !important;
}

/* --- Additional deficiencies — bottom actions left-aligned (Figma) --- */
app-additional-deficiencies-section .inspection-step-section-actions {
  justify-content: ${dt('deficiencyStepTable.additionalDeficienciesTable.sectionActionsJustifyContent')};
  gap: ${dt('deficiencyStepTable.additionalDeficienciesTable.sectionActionsGap')};
}

app-additional-deficiencies-section .inspection-step-section-actions app-action-buttons > div {
  gap: ${dt('deficiencyStepTable.additionalDeficienciesTable.sectionActionsGap')};
}

/* --- Figma 11832:27053 — detected (automatiniai) table only --- */
app-detected-deficiencies-section .accordion-section-content {
  padding-top: ${dt('deficiencyStepTable.detectedAutoTable.accordionToTableGap')};
}

app-detected-deficiencies-section .inspection-step-section-actions {
  margin-top: ${dt('deficiencyStepTable.detectedAutoTable.confirmActionsMarginTop')};
  justify-content: ${dt('deficiencyStepTable.detectedAutoTable.confirmActionsJustifyContent')};
  gap: ${dt('deficiencyStepTable.detectedAutoTable.confirmActionsGap')};
}

app-detected-deficiencies-section .inspection-step-section-actions app-action-buttons > div {
  gap: ${dt('deficiencyStepTable.detectedAutoTable.confirmActionsGap')};
}

app-detected-deficiencies-section table.inspection-step-table thead th {
  background: ${dt('deficiencyStepTable.detectedAutoTable.theadBackground')} !important;
  color: ${dt('deficiencyStepTable.detectedAutoTable.theadColor')} !important;
  padding: ${dt('deficiencyStepTable.detectedAutoTable.thPadding')} !important;
  border-bottom-color: ${dt('deficiencyStepTable.detectedAutoTable.theadBorderColor')} !important;
}

app-detected-deficiencies-section table.inspection-step-table tbody td app-date-field input.p-inputtext:disabled,
app-detected-deficiencies-section table.inspection-step-table tbody td app-date-field .p-disabled input.p-inputtext,
app-detected-deficiencies-section table.inspection-step-table tbody td app-multiline-field textarea:disabled {
  background: ${dt('deficiencyStepTable.detectedAutoTable.readonlyFieldBackground')} !important;
  border-color: ${dt('surface.100')} !important;
}

app-detected-deficiencies-section table.inspection-step-table thead th:nth-child(1) {
  width: ${dt('deficiencyStepTable.detectedAutoTable.colCreatedDate')};
}

app-detected-deficiencies-section table.inspection-step-table thead th:nth-child(2) {
  width: ${dt('deficiencyStepTable.detectedAutoTable.colActivities')};
}

app-detected-deficiencies-section table.inspection-step-table thead th:nth-child(3),
app-detected-deficiencies-section table.inspection-step-table thead th:nth-child(4) {
  width: auto;
}

app-detected-deficiencies-section table.inspection-step-table thead th:nth-child(5) {
  width: ${dt('deficiencyStepTable.detectedAutoTable.colDeadline')};
}

app-detected-deficiencies-section app-inspection-activity-select {
  max-width: 100%;
}

app-detected-deficiencies-section table.inspection-step-table tbody td app-inspection-activity-select .p-multiselect,
app-detected-deficiencies-section table.inspection-step-table tbody td app-date-field input.p-inputtext {
  min-height: ${dt('deficiencyStepTable.detectedAutoTable.controlMinHeight')};
}

/* --- Figma 11880:85174 — previous deficiencies table only --- */
app-previous-deficiencies-section table.inspection-step-table thead th {
  background: ${dt('deficiencyStepTable.previousDeficienciesTable.theadBackground')} !important;
  color: ${dt('deficiencyStepTable.previousDeficienciesTable.theadColor')} !important;
  padding: ${dt('deficiencyStepTable.previousDeficienciesTable.thPadding')} !important;
  border-bottom-color: ${dt('deficiencyStepTable.previousDeficienciesTable.theadBorderColor')} !important;
}

app-previous-deficiencies-section tr.previous-deficiency-confirm-row {
  background: ${dt('deficiencyStepTable.previousConfirmRow.background')};
}

app-previous-deficiencies-section tr.previous-deficiency-confirm-row--editing {
  background: ${dt('deficiencyStepTable.previousConfirmRow.editBackground')} !important;
}

app-previous-deficiencies-section table.inspection-step-table tbody tr.previous-deficiency-confirm-row td {
  vertical-align: middle;
  border-bottom-color: ${dt('deficiencyStepTable.previousConfirmRow.borderColor')} !important;
}

app-previous-deficiencies-section tr.previous-deficiency-confirm-row td.previous-deficiency-confirm-row-title {
  color: ${dt('deficiencyStepTable.previousConfirmRow.titleColor')};
  font-size: ${dt('deficiencyStepTable.previousDeficienciesTable.confirmTitleFontSize')};
  line-height: ${dt('deficiencyStepTable.previousDeficienciesTable.confirmTitleLineHeight')};
}

app-previous-deficiencies-section .p-accordionheader-link {
  font-size: ${dt('deficiencyStepTable.previousAccordionTitle.fontSize')} !important;
  line-height: ${dt('deficiencyStepTable.previousAccordionTitle.lineHeight')} !important;
}

app-previous-deficiencies-section .previous-deficiency-accordion-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${dt('deficiencyStepTable.previousAccordionTitle.segmentGap')};
}

app-previous-deficiencies-section .previous-deficiency-accordion-title-part {
  display: inline;
}

app-previous-deficiencies-section .previous-deficiency-accordion-title-reg {
  color: ${dt('deficiencyStepTable.previousAccordionTitle.registrationColor')};
}

app-previous-deficiencies-section .previous-deficiency-accordion-title-name {
  color: ${dt('deficiencyStepTable.previousAccordionTitle.nameColor')};
}

app-previous-deficiencies-section .previous-deficiency-accordion-title-separator {
  color: ${dt('deficiencyStepTable.previousAccordionTitle.separatorColor')};
}

app-previous-deficiencies-section app-implementation-of-deficiency-plan-tag .p-tag {
  min-height: ${dt('deficiencyStepTable.previousDeficienciesTable.statusBadgeMinHeight')};
  padding: ${dt('deficiencyStepTable.previousDeficienciesTable.statusBadgePadding')} !important;
  font-size: ${dt('deficiencyStepTable.previousDeficienciesTable.statusBadgeFontSize')} !important;
  font-weight: ${dt('deficiencyStepTable.previousDeficienciesTable.statusBadgeFontWeight')} !important;
  line-height: ${dt('deficiencyStepTable.previousDeficienciesTable.statusBadgeLineHeight')} !important;
}

app-previous-deficiencies-section app-implementation-of-deficiency-plan-tag .p-tag .p-tag-label {
  line-height: ${dt('deficiencyStepTable.previousDeficienciesTable.statusBadgeLineHeight')} !important;
}

app-previous-deficiencies-section app-implementation-of-deficiency-plan-tag .p-tag.p-tag-success {
  background: ${dt('deficiencyStepTable.previousDeficienciesTable.statusImplementedBackground')} !important;
  color: ${dt('deficiencyStepTable.previousDeficienciesTable.statusImplementedColor')} !important;
}

app-previous-deficiencies-section app-implementation-of-deficiency-plan-tag .p-tag.p-tag-danger {
  background: ${dt('deficiencyStepTable.previousDeficienciesTable.statusNotImplementedBackground')} !important;
  color: ${dt('deficiencyStepTable.previousDeficienciesTable.statusNotImplementedColor')} !important;
}

app-previous-deficiencies-section app-implementation-of-deficiency-plan-tag .p-tag.p-tag-warn {
  background: ${dt('deficiencyStepTable.previousDeficienciesTable.statusPartialBackground')} !important;
  color: ${dt('deficiencyStepTable.previousDeficienciesTable.statusPartialColor')} !important;
}

app-previous-deficiencies-section app-implementation-of-deficiency-plan-tag .p-tag.p-tag-secondary {
  background: ${dt('deficiencyStepTable.previousDeficienciesTable.statusUnconfirmedBackground')} !important;
  color: ${dt('deficiencyStepTable.previousDeficienciesTable.statusUnconfirmedColor')} !important;
}

app-previous-deficiencies-section tr.previous-deficiency-confirm-row .previous-deficiency-deadline-dash {
  color: ${dt('deficiencyStepTable.previousConfirmRow.deadlineDashColor')};
}

/* Confirm-row control cells: consistent top-align + padding in both edit and view modes. */
app-previous-deficiencies-section tr.previous-deficiency-confirm-row td:has(> app-select),
app-previous-deficiencies-section tr.previous-deficiency-confirm-row td:has(> app-date-field),
app-previous-deficiencies-section tr.previous-deficiency-confirm-row td:has(> app-implementation-of-deficiency-plan-tag),
app-previous-deficiencies-section tr.previous-deficiency-confirm-row td:has(> span.deficiency-implementation-missing),
app-previous-deficiencies-section tr.previous-deficiency-confirm-row td:has(> span.block) {
  vertical-align: top !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

/* Make component hosts behave as blocks so w-full / width:100% works. */
app-previous-deficiencies-section tr.previous-deficiency-confirm-row app-select.previous-deficiency-status-select,
app-previous-deficiencies-section tr.previous-deficiency-confirm-row app-date-field.previous-deficiency-deadline-picker {
  display: block;
  width: 100%;
}

app-previous-deficiencies-section tr.previous-deficiency-confirm-row .previous-deficiency-status-select .p-select {
  height: ${dt('deficiencyStepTable.previousDeficienciesTable.confirmControlMinHeight')};
  width: 100%;
  box-sizing: border-box;
}

app-previous-deficiencies-section tr.previous-deficiency-confirm-row .previous-deficiency-status-select .p-select-label {
  color: ${dt('select.color')};
  font-size: ${dt('deficiencyStepTable.previousDeficienciesTable.confirmControlFontSize')} !important;
  line-height: ${dt('deficiencyStepTable.previousDeficienciesTable.confirmControlLineHeight')} !important;
  padding: ${dt('deficiencyStepTable.previousDeficienciesTable.confirmControlPaddingY')}
    ${dt('deficiencyStepTable.previousDeficienciesTable.confirmControlPaddingX')};
}

app-previous-deficiencies-section tr.previous-deficiency-confirm-row .previous-deficiency-status-select .p-select-dropdown {
  width: 35px;
}

app-previous-deficiencies-section tr.previous-deficiency-confirm-row .previous-deficiency-deadline-picker input.p-inputtext {
  height: ${dt('deficiencyStepTable.previousDeficienciesTable.confirmControlMinHeight')};
  width: 100%;
  font-size: ${dt('deficiencyStepTable.previousDeficienciesTable.confirmControlFontSize')};
  line-height: ${dt('deficiencyStepTable.previousDeficienciesTable.confirmControlLineHeight')};
  padding-top: ${dt('deficiencyStepTable.previousDeficienciesTable.confirmControlPaddingY')};
  padding-bottom: ${dt('deficiencyStepTable.previousDeficienciesTable.confirmControlPaddingY')};
  box-sizing: border-box;
}

app-previous-deficiencies-section tr.previous-deficiency-confirm-row .previous-deficiency-deadline-picker input.p-inputtext:disabled,
app-previous-deficiencies-section tr.previous-deficiency-confirm-row .previous-deficiency-deadline-picker .p-disabled input.p-inputtext {
  background: ${dt('deficiencyStepTable.previousDeficienciesTable.disabledFieldBackground')} !important;
  border-color: ${dt('surface.100')} !important;
}

app-previous-deficiencies-section tr.previous-deficiency-confirm-row td:last-child app-action-buttons .p-button:has(.p-button-label) {
  width: 100%;
  justify-content: center;
}

/* Figma 11780:47705 — "Patvirtinti" (label) button: flat blue, no hover/focus state */
app-previous-deficiencies-section tr.previous-deficiency-confirm-row td:last-child app-action-buttons .p-button:has(.p-button-label):hover,
app-previous-deficiencies-section tr.previous-deficiency-confirm-row td:last-child app-action-buttons .p-button:has(.p-button-label):focus-visible {
  background: ${dt('primary.400')} !important;
  box-shadow: none !important;
}

/* Figma 11880:85213 — icon-only action button in confirm row: no hover/focus styling */
app-previous-deficiencies-section tr.previous-deficiency-confirm-row td:last-child app-action-buttons .p-button:not(:has(.p-button-label)):hover,
app-previous-deficiencies-section tr.previous-deficiency-confirm-row td:last-child app-action-buttons .p-button:not(:has(.p-button-label)):focus-visible {
  background: transparent !important;
  border-color: transparent !important;
  box-shadow: none !important;
}

app-detected-deficiencies-section table.inspection-step-table tbody td .deficiency-unregistered-activity-field,
app-additional-deficiencies-section .app-editable-row-table tbody td .deficiency-unregistered-activity-field {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: ${dt('deficiencyStepTable.detectedAutoTable.controlMinHeight')};
  padding: ${dt('form.field.md.padding.y')} ${dt('form.field.md.padding.x')};
  box-sizing: border-box;
  border: 1px solid ${dt('surface.100')};
  border-radius: ${dt('multiselect.border.radius')};
  background: ${dt('deficiencyStepTable.detectedAutoTable.readonlyFieldBackground')};
  color: ${dt('datatable.row.color')};
  font-size: ${dt('form.field.md.font.size')};
  line-height: ${dt('form.field.md.font.lineHeight')};
  word-break: break-word;
}

.deficiency-unregistered-activity-field {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: ${dt('deficiencyStepTable.detectedAutoTable.controlMinHeight')};
  padding: ${dt('form.field.md.padding.y')} ${dt('form.field.md.padding.x')};
  box-sizing: border-box;
  border: 1px solid ${dt('surface.100')};
  border-radius: ${dt('multiselect.border.radius')};
  background: ${dt('deficiencyStepTable.detectedAutoTable.readonlyFieldBackground')};
  color: ${dt('datatable.row.color')};
  font-size: ${dt('form.field.md.font.size')};
  line-height: ${dt('form.field.md.font.lineHeight')};
  word-break: break-word;
}


`;
